import React from 'react';

import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { SelectHierarchyLabel } from '@weezevent/nacre';
import { translateCountry } from '../../pages/attendee/detail/components/utils';
import i18n from 'i18next';

function rateOption(tax) {
    const val = tax.tax_values.tax_supplemental_value ? tax.tax_values.tax_value + tax.tax_values.tax_supplemental_value : tax.tax_values.tax_value;

    return {
        key: tax.id,
        text: `${tax.label.replace('%1$s', `${val}%`)} - ${tax.country}`,
        value: tax.id,
        parent: tax.country,
        tax_value: val
    };
}

export default function SelectTaxes({
    options = null,
    taxes = null,
    onChange = () => {},
    value = null,
    label = 'Tax',
    placeholder = 'ticket.event.tax_placeholder',
    placeholderSearch = 'ticket.common.action.search',
    height = 'medium',
    ellipsis = false,
    errors = [],
    disabled = false,
    withOptionTaxEvent = false,
    ...rest
}) {
    const { t } = useTranslation();
    const locale = i18n.language;
    const optionTaxEvent = {
        key: 'event',
        text: t('ticket.rates.infos.eventTax'),
        value: 'event'
    };

    const taxsOptions = React.useMemo(() => {
        if (options) {
            return options;
        }

        if (!taxes) {
            return [];
        }

        let _options = withOptionTaxEvent ? [optionTaxEvent] : [];

        taxes.forEach(tax => {
            if (tax.country === '' && tax.id === 0) {
                _options.push({ key: tax.id, text: tax.label, value: tax.id, tax_value: tax.tax_values.tax_value });
                return;
            }
            //@Todo case particular optgroup, synchro optgroup in Pyvar
            if ([11, 12, 13, 14, 15].includes(tax.id)) {
                tax.country = 'DOM-TOM';
            }
            let groupIndex = _options.findIndex(opt => opt.value === tax.country);
            //Create group with child
            if (groupIndex === -1) {
                _options.push({
                    key: tax.country,
                    text: tax.country === 'DOM-TOM' ? tax.country : translateCountry(locale, tax.country),
                    value: tax.country,
                    children: [rateOption(tax)]
                });
                return;
            }
            //Put child in group if group already created
            _options[groupIndex].children.push(rateOption(tax));
        });

        //Sort ASC by tax_value except Canada
        return _options.map(opt => {
            if (opt?.children && opt.value !== 'CA') {
                opt.children.sort((child_1, child_2) => child_1.tax_value - child_2.tax_value);
            }
            return opt;
        });
    }, [taxes, locale, rateOption, withOptionTaxEvent, optionTaxEvent]);

    if (!taxes && !options) {
        return null;
    }

    return (
        <SelectHierarchyLabel
            onChange={(optionValue, option) => onChange(optionValue, option)}
            options={taxsOptions}
            value={value}
            placeholder={t(placeholder)}
            placeholderSearch={t(placeholderSearch)}
            searchable={true}
            height={height}
            ellipsis={ellipsis}
            errors={errors}
            disabled={disabled}
            widthIndent="10px"
            label={label}
            {...rest}
        />
    );
}

SelectTaxes.propTypes = {
    taxes: PropTypes.array,
    options: PropTypes.array,
    onChange: PropTypes.func,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    label: PropTypes.node,
    placeholder: PropTypes.string,
    placeholderSearch: PropTypes.string,
    height: PropTypes.oneOf(['mini', 'medium', 'maxi']),
    ellipsis: PropTypes.bool,
    errors: PropTypes.array,
    disabled: PropTypes.bool,
    withOptionTaxEvent: PropTypes.bool
};
